import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import {
  getMediaAttributes,
  isHTMLElementNode,
} from '../helpers/serializerHelpers';
import { type AudioElement } from '../../types/aha-editor';
import { isAudioElement } from '../../types/guards';

class SerializerAudio extends Serializer {
  static deserialize({ el }: DeserializeArguments): AudioElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'audio') return;

    return {
      type: 'audio',
      children: [{ text: '' }],
      ...getMediaAttributes(el),
    };
  }

  static serialize({ node }: SerializeArguments): React.ReactNode {
    if (!isAudioElement(node)) return;

    const { media_src, media_position, media_alt } = node;

    return (
      <audio
        data-position={media_position}
        src={media_src}
        aria-label={media_alt}
        controls
      />
    );
  }
}

export default SerializerAudio;
